import React from "react";
import { useContent } from "@/contexts/ContentContext";
import SiteDisabled from "@/pages/SiteDisabled";
import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import About from "@/components/sections/About";
import Portfolio from "@/components/sections/Portfolio";
import Process from "@/components/sections/Process";
import Testimonials from "@/components/sections/Testimonials";
import ServiceAreas from "@/components/sections/ServiceAreas";
import CtaBanner from "@/components/sections/CtaBanner";
import ContactForm from "@/components/sections/ContactForm";
import Footer from "@/components/sections/Footer";
import MobileBar from "@/components/sections/MobileBar";
import FloatingActions from "@/components/sections/FloatingActions";

export default function Landing() {
  const { content, loading, error } = useContent();

  if (loading || !content) {
    if (error && /503/.test(String(error))) {
      return <SiteDisabled />;
    }
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-gray-500 font-body">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-2 border-[#D4AF37]/30 border-t-[#D4AF37] rounded-full animate-spin" />
          <span className="text-sm tracking-widest uppercase">Loading…</span>
        </div>
      </div>
    );
  }

  const s = content.sections;
  const site = content.site;

  return (
    <main className="bg-white text-[#0A0A0A] font-body overflow-hidden" data-testid="landing-page">
      <Nav site={site} />
      {s.hero?.enabled && <Hero data={s.hero} site={site} />}
      {s.services?.enabled && <Services data={s.services} />}
      {s.about?.enabled && <About data={s.about} />}
      {s.portfolio?.enabled && <Portfolio data={s.portfolio} />}
      {s.process?.enabled && <Process data={s.process} />}
      {s.testimonials?.enabled && <Testimonials data={s.testimonials} />}
      {s.areas?.enabled && <ServiceAreas data={s.areas} />}
      {s.cta?.enabled && <CtaBanner data={s.cta} site={site} />}
      {s.contact?.enabled && <ContactForm data={s.contact} site={site} />}
      {s.footer?.enabled && <Footer data={s.footer} site={site} services={s.services?.items || []} />}
      <MobileBar site={site} />
      <FloatingActions site={site} />
    </main>
  );
}
